import { SeoMeta } from './seo.config';

const KEYWORDS =
  'VEVAROK, digital khata, udhar khata, bahi khata, jama udhar, personal credit debit, money ledger app';

export const SEO_HOME: SeoMeta = {
  title: 'VEVAROK | Digital Khata App for Personal Credit & Debit',
  description:
    'Track Jama, Udhar, expenses and pending payments with VEVAROK. AI-powered digital khata for personal credit and debit on Android, iOS and Web.',
  keywords: KEYWORDS,
  jsonLd: 'home',
  breadcrumb: 'Home'
};

export const SEO_ABOUT: SeoMeta = {
  title: 'About VEVAROK | Softwagon Technologies Digital Khata',
  description:
    'VEVAROK by Softwagon Technologies makes personal credit and debit simple. Record Jama, Udhar, reminders and reports in one secure digital khata.',
  keywords: `${KEYWORDS}, about vevarok, softwagon technologies`,
  jsonLd: 'about',
  breadcrumb: 'About Us'
};

export const SEO_SERVICES: SeoMeta = {
  title: 'VEVAROK Services | Digital Ledger, Reminders & Reports',
  description:
    'Explore VEVAROK services — AI voice entry, payment reminders, party-wise reports, multi-device sync and a secure personal digital khata.',
  keywords: `${KEYWORDS}, voice entry, payment reminders, ledger reports`,
  jsonLd: 'services',
  breadcrumb: 'Services'
};

export const SEO_PRICING: SeoMeta = {
  title: 'VEVAROK Pricing | Free, Plus & Premium Plans',
  description:
    'Choose a VEVAROK plan that fits you. Start free to track personal credit and debit, then upgrade for unlimited entries, reports and exports.',
  keywords: `${KEYWORDS}, vevarok pricing, free khata app`,
  jsonLd: 'pricing',
  breadcrumb: 'Pricing'
};

export const SEO_BLOG: SeoMeta = {
  title: 'VEVAROK Blog | Personal Finance & Digital Khata Tips',
  description:
    'Read guides on digital khata, Jama-Udhar tracking, payment reminders and personal money management from the VEVAROK team.',
  keywords: `${KEYWORDS}, vevarok blog, personal finance tips`,
  jsonLd: 'blog',
  breadcrumb: 'Blog'
};

export const SEO_ARTICLE: SeoMeta = {
  title: 'VEVAROK Blog Article',
  description: 'Read the latest from VEVAROK on personal credit, debit and digital khata.',
  keywords: `${KEYWORDS}, vevarok article`,
  type: 'article',
  jsonLd: 'article',
  breadcrumb: 'Article'
};

export const SEO_FAQ: SeoMeta = {
  title: 'VEVAROK FAQs | Digital Khata Help',
  description:
    'Answers about VEVAROK — pricing, devices, languages, reminders, data security and how to manage personal credit and debit.',
  keywords: `${KEYWORDS}, vevarok faq, digital khata help`,
  jsonLd: 'faq',
  breadcrumb: 'FAQs'
};

export const SEO_CONTACT: SeoMeta = {
  title: 'Contact VEVAROK | Support & Softwagon Technologies',
  description:
    'Contact VEVAROK support in Ahmedabad. Email support@vevarok.com or call +91 9974588878 for digital khata help.',
  keywords: `${KEYWORDS}, vevarok contact, ahmedabad`,
  jsonLd: 'contact',
  breadcrumb: 'Contact Us'
};

export const SEO_DOWNLOAD: SeoMeta = {
  title: 'Download VEVAROK | Android, iOS & Web App',
  description:
    'Download the VEVAROK digital khata app for Android, iOS and Web. Track Jama, Udhar and expenses anywhere with secure cloud sync.',
  keywords: `${KEYWORDS}, download vevarok, android khata app`,
  jsonLd: 'download',
  breadcrumb: 'Download App'
};

export const SEO_PRIVACY: SeoMeta = {
  title: 'Privacy Policy | VEVAROK',
  description:
    'Learn how VEVAROK collects, uses and protects your personal ledger data. Read the privacy policy from Softwagon Technologies.',
  keywords: `${KEYWORDS}, vevarok privacy policy`,
  jsonLd: 'legal',
  breadcrumb: 'Privacy Policy'
};

export const SEO_TERMS: SeoMeta = {
  title: 'Terms and Conditions | VEVAROK',
  description:
    'Read the VEVAROK terms and conditions for using our digital khata app, website and related services.',
  keywords: `${KEYWORDS}, vevarok terms`,
  jsonLd: 'legal',
  breadcrumb: 'Terms and Conditions'
};

export const SEO_ACCOUNT_DELETION: SeoMeta = {
  title: 'Account Deletion | VEVAROK',
  description:
    'Request deletion of your VEVAROK account and personal data. Follow the steps or email support@vevarok.com.',
  keywords: `${KEYWORDS}, delete vevarok account`,
  jsonLd: 'legal',
  breadcrumb: 'Account Deletion'
};

export const SEO_LOGIN: SeoMeta = {
  title: 'Login | VEVAROK Digital Khata',
  description:
    'Sign in to VEVAROK to manage your personal credit, debit, reminders and reports across Android, iOS and Web.',
  keywords: `${KEYWORDS}, vevarok login`,
  jsonLd: 'login',
  breadcrumb: 'Login'
};

export const SEO_COMING_SOON: SeoMeta = {
  title: 'Coming Soon | VEVAROK',
  description: 'This VEVAROK page is coming soon. Check back for updates on our digital khata app.',
  noIndex: true,
  breadcrumb: 'Coming Soon'
};

export const SEO_THANK_YOU: SeoMeta = {
  title: 'Thank You | VEVAROK',
  description: 'Thank you for contacting VEVAROK. Our support team will get back to you shortly.',
  noIndex: true,
  breadcrumb: 'Thank You'
};

export const SEO_NOINDEX: SeoMeta = {
  title: 'VEVAROK',
  description: 'VEVAROK digital khata — private workspace.',
  noIndex: true
};
